import React from "react";
import { ActionButtonsProps } from "../../types/messages.types";
import { UI_TEXT } from "../../constants/messages.constants";

/**
 * ActionButtons Component
 * Displays booking action buttons based on booking state
 */
const ActionButtons: React.FC<ActionButtonsProps> = ({
  bookingId,
  bookingQueryId,
  currentUser,
  onProceedToBooking,
  onProceedToPayment,
}) => {
  // Only show buttons if user is student or host and has booking data
  if (
    (!currentUser?.is_student && !currentUser?.is_host) ||
    (!bookingId && !bookingQueryId)
  ) {
    return null;
  }

  return (
    <div className="mb-6">
      {bookingId && (
        <button
          onClick={onProceedToPayment}
          className="w-full px-6 py-3 bg-[#F56948] text-white rounded-xl hover:bg-[#E5593D] transition-all font-medium shadow-sm hover:shadow-md"
        >
          {UI_TEXT.BUTTONS.VIEW_BOOKING}
        </button>
      )}
      {bookingQueryId && !bookingId && (
        <button
          onClick={onProceedToBooking}
          className="w-full px-6 py-3 bg-[#F56948] text-white rounded-xl hover:bg-[#E5593D] transition-all font-medium shadow-sm hover:shadow-md"
        >
          {UI_TEXT.BUTTONS.VIEW_QUERY}
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
